import { Contract } from "./contract";

export class Client {
    Code: string;
    Name: string;
    City: string;
    ContractList: Contract[] = [];

    static mapFromJSON(json) {
        const m = new Client();

        m.Code = json['code'];
        m.Name = json['name'];
        m.City = json['city'];
        if (json['contracts']) {
            m.ContractList = json['contracts'].map(item => Contract.mapFromJSON(item));
        }

        return m;
    }
}
